/*!
 * in-array <https://github.com/jonschlinkert/in-array>
 *
 * Copyright (c) 2014 Jon Schlinkert, contributors.
 * Licensed under the MIT License
 */

function inArray<T>(arr: T[], val: T): boolean {
  const targets = arr ?? [];
  const len = targets.length;

  for (let i = 0; i < len; i += 1) {
    if (targets[i] === val) {
      return true;
    }
  }

  return false;
}

export default inArray;
